export default __webpack_public_path__ + "static/media/chidera-robert-v1.51d2b064.png";